import { render, staticRenderFns } from "./OrderSetComplete.vue?vue&type=template&id=2f66138e&"
import script from "./OrderSetComplete.vue?vue&type=script&lang=js&"
export * from "./OrderSetComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports